// @flow strict
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import type {JobResponse} from 'src/types/referral-external';
import type {ReferralJob} from 'src/types/referral-v2';
import classify from 'src/utils/classify';
import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {
  BodyMedium,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';
import css from './jobs.css';


type JobCardProp = {
  selectJob: (id: string) => mixed,
  setJobDetailsOpen: (data: boolean) => mixed,
  handleSelectJob: (ReferralJob) => mixed,
  job: JobResponse,
};

export const JobCard = ({
  job,
  selectJob,
  handleSelectJob,
  setJobDetailsOpen,
}: JobCardProp): React.Node => {
  const {id, job_type, payment_type, bonus, title, location} = job || {};
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  return (
    <Card key={id} classNames={{wrapper: css.jobCard}}>
      <div className={css.cardContent}>
        <div className={css.panelCard}>
          <SubTitleLarge
            onClick={() => {
              selectJob(id);
              setJobDetailsOpen(true);
            }}
            className={css.jobTitle}
          >
            {title}
          </SubTitleLarge>
          <Button
            type="secondary"
            size="small"
            onClick={() => {
              handleSelectJob({id, title});
            }}
          >
            {t('Select', 'Select')}
          </Button>
        </div>
        <div className={css.panelCard}>
          <div className={css.chip}>
            {bonus &&
              bonus.amount > 0 &&
              (bonus.currency === 'USD' ? (
                <Chip
                  iconName="dollar"
                  semantic="primary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {`${bonus.amount} ${t('Bonus', 'Bonus')}`}
                </Chip>
              ) : (
                <Chip
                  semantic="primary"
                  classNames={{wrapper: css.chipCursor}}
                >{`${bonus.amount} ${t('Bonus', 'Bonus')}`}</Chip>
              ))}
            {job_type && (
              <Chip
                iconName="briefcase"
                semantic="primary"
                classNames={{wrapper: css.chipCursor}}
              >
                {job_type}
              </Chip>
            )}
            {payment_type && (
              <Chip
                iconName="wallet"
                semantic="primary"
                classNames={{wrapper: css.chipCursor}}
              >
                {payment_type}
              </Chip>
            )}
          </div>
          {location && <BodyMedium color="secondary">{location}</BodyMedium>}
        </div>
      </div>
    </Card>
  );
};

export const MobileViewJobCard = ({
  job,
  selectJob,
  handleSelectJob,
  setJobDetailsOpen,
}: JobCardProp): React.Node => {
  const {id, job_type, payment_type, bonus, title, location} = job || {};
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  return (
    <Card key={id} classNames={{wrapper: css.jobCard}}>
      <div className={css.cardContent}>
        <SubTitleLarge className={css.jobTitle}>{title}</SubTitleLarge>
        <div className={css.jobCard}>
          <div className={css.chip}>
            {bonus &&
              bonus.amount > 0 &&
              (bonus.currency === 'USD' ? (
                <Chip
                  iconName="dollar"
                  semantic="primary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {`${bonus.amount} ${t('Bonus', 'Bonus')}`}
                </Chip>
              ) : (
                <Chip
                  semantic="primary"
                  classNames={{wrapper: css.chipCursor}}
                >{`${bonus.amount} ${t('Bonus', 'Bonus')}`}</Chip>
              ))}
            {job_type && (
              <Chip
                iconName="briefcase"
                semantic="primary"
                classNames={{wrapper: css.chipCursor}}
              >
                {job_type}
              </Chip>
            )}
            {payment_type && (
              <Chip
                iconName="wallet"
                semantic="primary"
                classNames={{wrapper: css.chipCursor}}
              >
                {payment_type}
              </Chip>
            )}
          </div>
        </div>
        {location && (
          <BodyMedium className={css.jobCard} color="secondary">
            {location}
          </BodyMedium>
        )}
        <div className={classify(css.chip, css.jobCard)}>
          <Button
            type="primary"
            size="small"
            classNames={{wrapper: css.chip}}
            onClick={() => {
              handleSelectJob({id, title});
            }}
          >
            {t('Select', 'Select')}
          </Button>
          <Button
            type="secondary"
            size="small"
            onClick={() => {
              selectJob(id);
              setJobDetailsOpen(true);
            }}
          >
            {t('View_Details', 'View Details')}
          </Button>
        </div>
      </div>
    </Card>
  );
};
